if (!customElements.get('product-grid')) {
  class ProductGrid extends HTMLElement {
    constructor() {
      super();
      this.products = this.querySelectorAll('[data-collection-item]');
      this.imageBanner = this.querySelector('[data-collection-banner]');
      this.bannerPosition = 2;
      this.moveBanner();
      window.addEventListener('resize', () => {
        this.moveBanner();
      });
    }

    moveBanner() {
      // Check screen size and update banner position
      if (window.innerWidth < 768) {
        this.bannerPosition = 2;
      } else if (window.innerWidth < 1200) {
        this.bannerPosition = 3;
      } else {
        this.bannerPosition = 4;
      }

      // Move banner to new position
      if (this.products.length > this.bannerPosition) {
        this.products[this.bannerPosition - 1].insertAdjacentElement('afterend', this.imageBanner);
        this.imageBanner.classList.remove('hidden');
      }
    }
  }

  window.ProductGrid = ProductGrid;
  customElements.define('product-grid', ProductGrid);
}
